(function () {
  if (window.__productInfoSnippetInit) return;
  window.__productInfoSnippetInit = true;

  function readConfig(el, attrName) {
    var id = el.getAttribute(attrName);
    if (!id) return null;
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ── Concern A: product description image wrapping ── */
  function initDescription(root) {
    var config = readConfig(root, 'data-product-info-description-config-id');
    if (!config) return;
    const descriptionContainer = document.getElementById('product-description-' + config.block_id);
    if (descriptionContainer) {
      const images = descriptionContainer.querySelectorAll('img');
      images.forEach(function(img) {
        img.classList.add('description-image');
        // Ensure images don't have inline width/height that could cause overflow
        img.removeAttribute('width');
        img.removeAttribute('height');
        // Wrap image in a container for better control
        if (!img.parentElement.classList.contains('description-image-wrapper')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'description-image-wrapper';
          img.parentNode.insertBefore(wrapper, img);
          wrapper.appendChild(img);
        }
      });
    }
  }

  /* ── Concern B: dynamic variant title ── */
  function initDynamicTitle(root) {
    var config = readConfig(root, 'data-product-info-dynamic-title-config-id');
    if (!config) return;
    var blockId = config.block_id;
    window['productVariants_' + blockId] = config.product_variants;
    window['productOptions_' + blockId] = config.product_options;

    const titleElement = document.querySelector('.product-title-' + blockId);
    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (!titleElement || !productForm) return;

    const dynamicOption = titleElement.getAttribute('data-dynamic-variant-option');
    const originalTitle = titleElement.getAttribute('data-original-title');
    const productVariants = window['productVariants_' + blockId] || [];
    const productOptions = window['productOptions_' + blockId] || [];

    if (!dynamicOption || dynamicOption === 'none') return;

    const optionIndex = parseInt(dynamicOption) - 1; // Convert to 0-based index

    // Function to update title based on variant option
    function updateTitle(variantId) {
      if (!variantId) return;

      const variant = productVariants.find(v => v.id == variantId);

      if (variant) {
        // Get the option value based on selected option index (option1, option2, option3)
        let optionValue = null;
        if (optionIndex === 0 && variant.option1) {
          optionValue = variant.option1;
        } else if (optionIndex === 1 && variant.option2) {
          optionValue = variant.option2;
        } else if (optionIndex === 2 && variant.option3) {
          optionValue = variant.option3;
        }

        if (optionValue && optionValue !== 'Default Title') {
          titleElement.textContent = optionValue;
        } else {
          titleElement.textContent = originalTitle;
        }
      } else {
        titleElement.textContent = originalTitle;
      }
    }

    // Listen for variant changes
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant) {
        updateTitle(event.detail.variant.id);
      }
    });

    // Also listen for form input changes
    const variantInput = productForm.querySelector('[name="id"]');
    if (variantInput) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            updateTitle(variantInput.value);
          }
        });
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      // Also listen for direct value changes
      variantInput.addEventListener('change', function() {
        updateTitle(this.value);
      });

      // Set initial title if variant is pre-selected
      if (variantInput.value) {
        updateTitle(variantInput.value);
      }
    }
  }

  /* ── Concern C: ATC globals + variant strings (script #3) ── */
  function initAtcGlobals(root) {
    var config = readConfig(root, 'data-product-info-atc-globals-config-id');
    if (!config) return;
    // Make translations available to JS
    window.variantStrings = window.variantStrings || {};
    window.variantStrings.addToCart = config.add_to_cart;
    window.variantStrings.soldOut = config.sold_out;
    window.variantStrings.adding = config.adding;
    window.variantStrings.added = config.added;

    // Expose as globals — read by other product-info snippets (simple-variant-picker,
    // quantity-break, variant-picker-hybrid, segmented-variant-picker, modern-quantity-selector)
    // and assets/product-form.js, which read these as bare globals.
    window.addToCartButtonText = config.button_text_for_initial_render;
    window.showPriceButton = config.show_price_in_button;
  }

  /* ── Concern D: ATC button text + qty stepper + skipToCheckout (script #4) ── */
  function skipToCheckout() {
    setTimeout(() => {
      window.location.href='/checkout';
    }, 300);
  }
  // Expose for inline onclick="skipToCheckout()" handler in markup
  window.skipToCheckout = skipToCheckout;

  function onDomReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initAtcButton(root) {
    var config = readConfig(root, 'data-product-info-atc-button-config-id');
    if (!config) return;

    /* ── Inline Qty Stepper ── */
    (function() {
      var wrapper = document.querySelector('.atc-inline-row--has-qty');
      if (!wrapper) return;

      var display = wrapper.querySelector('[data-atc-qty-display]');
      var input = wrapper.closest('form').querySelector('[data-atc-qty-input]');
      var qty = 1;

      wrapper.querySelectorAll('.atc-qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var action = btn.dataset.atcQtyAction;
          if (action === 'increase') qty = Math.min(10, qty + 1);
          if (action === 'decrease') qty = Math.max(1, qty - 1);
          if (display) display.textContent = qty;
          if (input) input.value = qty;
          document.dispatchEvent(new CustomEvent('quantity:changed', { detail: { qty: qty } }));
        });
      });
    })();

    onDomReady(function () {
      if(showPriceButton) {
        const productInfoContainer = document.querySelector('.shop-product-info');
        if(!productInfoContainer) return;

        const mainAtcBtn = document.querySelector('.shop-add-to-cart-button');

        const variantSelectorBlock = document.querySelector('.simple-variant-picker');
        const quantityBreakBlock = document.querySelector('.quantity-break-container');
        const quantityBundleBlock = document.querySelector('.quantity-bundle-selector');
        const quantityBundleCustomPrice = quantityBundleBlock?.dataset.customPrice === 'true';

        const variants = config.product_variants;

        const amountFormatter = (amount, showSymbol = false) => {
          if (amount === null || amount === undefined || amount === '') return '';

          const cents = typeof amount === 'number' ? amount : parseFloat(amount);
          if (Number.isNaN(cents)) return '';

          const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
          const normalizedCents = Math.round(cents * rate);

          if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
            const formatString = showSymbol
              ? Shopify.money_with_currency_format ||
                Shopify.money_format ||
                window.Shopify?.currency?.active_format ||
                '{{amount}}'
              : Shopify.money_without_currency_format ||
                Shopify.money_format ||
                window.Shopify?.currency?.active_format ||
                '{{amount}}';
            return Shopify.formatMoney(normalizedCents, formatString);
          }

          const currency = window.Shopify?.currency?.active || 'USD';
          const normalizedAmount = normalizedCents / 100;

          return new Intl.NumberFormat(undefined, {
            style: showSymbol ? 'currency' : 'decimal',
            currency,
            minimumFractionDigits: currency === 'JPY' ? 0 : 2,
            maximumFractionDigits: currency === 'JPY' ? 0 : 2
          }).format(normalizedAmount);
        };

        const getSelectedVariant = () => {
          if(!variantSelectorBlock) return;

          let currentVariant = null;

          const selectedOptions = variantSelectorBlock.querySelectorAll('input:checked, select');

          if(selectedOptions.length > 0) {
            const variantTitle = Array.from(selectedOptions).map(option => option.value).join(' / ');

            const selectedVariant = variants.filter(variant => variant.title === variantTitle)[0];

            if(selectedVariant) currentVariant = selectedVariant;
          }

          return currentVariant;
        };

        const getSelectedBundle = () => {
          if(!quantityBreakBlock) return;

          let bundle = {
            price: config.selected_variant_price,
            comparePrice: config.selected_variant_compare_price,
          };

          const selectedBundle = quantityBreakBlock.querySelector('.quantity-break-option-container:has(input:checked)');

          if(selectedBundle) {
            const price = selectedBundle.querySelector('.quantity-break-price');
            const comparePrice = selectedBundle.querySelector('.quantity-break-original-price');

            if(price) bundle.price = price.innerText;
            if(comparePrice) bundle.comparePrice = comparePrice.innerText;
          }

          return bundle;
        };

        const updateBtnText = () => {
          if (quantityBundleCustomPrice) {
            return;
          }
          const btnText = mainAtcBtn.querySelector('.button-text') || null;
          const persistentText = mainAtcBtn.dataset.persistentText || config.button_text_for_initial_render;

          let btnTextWithPriceText = `${persistentText} - [price]<span class="compare-price">([comparePrice])</span>`;

          if(quantityBreakBlock) {
            const { price, comparePrice } = getSelectedBundle();

            btnTextWithPriceText = btnTextWithPriceText.replace('[price]', price);

            if(comparePrice && comparePrice !== '') {
              btnTextWithPriceText = btnTextWithPriceText.replace('[comparePrice]', comparePrice);
            } else {
              btnTextWithPriceText = btnTextWithPriceText.replace('<span class="compare-price">([comparePrice])</span>', '');
            }
          } else if(variantSelectorBlock) {
            const selectedVariant = getSelectedVariant();

            if(!selectedVariant) return;

            const variantPrice = amountFormatter(selectedVariant.price, true) || null;
            const variantComparePrice = amountFormatter(selectedVariant.compare_at_price, true) || null;

            btnTextWithPriceText = btnTextWithPriceText.replace('[price]', variantPrice);

            if(variantComparePrice) {
              btnTextWithPriceText = btnTextWithPriceText.replace('[comparePrice]', variantComparePrice);
            } else {
              btnTextWithPriceText = btnTextWithPriceText.replace('<span class="compare-price">([comparePrice])</span>', '');
            }
          }

          btnText.innerHTML = btnTextWithPriceText;
        };

        productInfoContainer.addEventListener('change', updateBtnText);
      }
    });
  }

  /* ── Concern E: customer review carousel ── */
  function initReviewCarousel(root) {
    var config = readConfig(root, 'data-product-info-review-carousel-config-id');
    if (!config) return;
    onDomReady(function() {
      const carousel = document.getElementById('customer-review-carousel-' + config.block_id);
      if (!carousel) return;

      const slidesContainer = carousel.querySelector('.customer-review-slides');
      const slides = carousel.querySelectorAll('.customer-review-slide');
      const dots = carousel.querySelectorAll('.pagination-dot');

      // Start with the middle card
      const middleIndex = Math.floor(slides.length / 2);
      let currentSlide = middleIndex;
      let startX = 0;
      let currentX = 0;
      let isDragging = false;
      let startTransform = 0;

      function goToSlide(index, instant = false) {
        // Infinite scroll logic - normalize the index
        if (index >= slides.length) {
          currentSlide = 0;
        } else if (index < 0) {
          currentSlide = slides.length - 1;
        } else {
          currentSlide = index;
        }

        // Calculate the offset to center the active slide
        // Container is 80% width and centered by parent
        // Each slide is 100% of container width with 12px gap
        // Add small offset to shift more to the left
        const slideOffset = currentSlide * 100;
        const leftOffset = -3; // Shift 5% more to the left

        if (instant) {
          slidesContainer.style.transition = 'none';
        }

        slidesContainer.style.transform = `translateX(calc(${leftOffset}% - ${slideOffset}%))`;

        if (instant) {
          // Force reflow
          slidesContainer.offsetHeight;
          slidesContainer.style.transition = 'transform 0.4s ease-out';
        }

        // Update active class on slides
        slides.forEach((slide, i) => {
          slide.classList.toggle('active', i === currentSlide);
        });

        // Update dots
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === currentSlide);
        });
      }

      function nextSlide() {
        goToSlide(currentSlide + 1);
      }

      function prevSlide() {
        goToSlide(currentSlide - 1);
      }

      // Dot navigation
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          goToSlide(index);
        });
      });

      // Touch/Swipe functionality
      function handleStart(e) {
        isDragging = true;
        startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
        const leftOffset = -5;
        startTransform = leftOffset - (currentSlide * 100);
        slidesContainer.style.transition = 'none';
      }

      function handleMove(e) {
        if (!isDragging) return;
        e.preventDefault();

        currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
        const diff = currentX - startX;
        const containerWidth = slidesContainer.offsetWidth;
        const percentMoved = (diff / containerWidth) * 100;

        slidesContainer.style.transform = `translateX(${startTransform + percentMoved}%)`;
      }

      function handleEnd(e) {
        if (!isDragging) return;
        isDragging = false;

        slidesContainer.style.transition = 'transform 0.4s ease-out';

        const diff = currentX - startX;
        const threshold = 50; // Minimum swipe distance

        if (Math.abs(diff) > threshold) {
          if (diff > 0) {
            // Swiped right - go to previous
            prevSlide();
          } else {
            // Swiped left - go to next
            nextSlide();
          }
        } else {
          // Didn't swipe far enough, return to current slide
          goToSlide(currentSlide);
        }
      }

      // Mouse events
      slidesContainer.addEventListener('mousedown', handleStart);
      document.addEventListener('mousemove', handleMove);
      document.addEventListener('mouseup', handleEnd);

      // Touch events
      slidesContainer.addEventListener('touchstart', handleStart, { passive: false });
      slidesContainer.addEventListener('touchmove', handleMove, { passive: false });
      slidesContainer.addEventListener('touchend', handleEnd);

      // Prevent text selection while dragging
      slidesContainer.addEventListener('dragstart', (e) => e.preventDefault());

      // Initialize with the middle card
      goToSlide(middleIndex);
    });
  }

  /* ── Concern F: custom field validation ── */
  function initCustomField(root) {
    var config = readConfig(root, 'data-product-info-custom-field-config-id');
    if (!config) return;
    var fieldId = config.field_id;
    var hasMaxLength = config.has_max_length;
    var maxLength = config.max_length;
    var requiredField = config.required_field;
    var inputBorderColor = config.input_border_color || '#d1d5db';

    onDomReady(function() {
      const field = document.getElementById(fieldId);
      const wrapper = document.getElementById('wrapper-' + fieldId);
      var currentCounter = null;
      if (hasMaxLength) {
        currentCounter = document.getElementById('current-' + fieldId);
      }

      if (field) {
        function updateCounter() {
          const currentLength = field.value.length;
          if (currentCounter) {
            currentCounter.textContent = currentLength;

            // Change color as approaching limit
            if (currentLength > maxLength * 0.9) {
              currentCounter.style.color = '#dc2626'; // Red
            } else if (currentLength > maxLength * 0.7) {
              currentCounter.style.color = '#f59e0b'; // Amber
            } else {
              currentCounter.style.color = '#6b7280'; // Gray
            }
          }
        }

        if (hasMaxLength) {
          // Character counter functionality
          field.addEventListener('input', updateCounter);
          field.addEventListener('paste', function() {
            setTimeout(updateCounter, 10);
          });
        }

        if (requiredField) {
          // Required field validation
          function validateField() {
            const value = field.value.trim();
            if (value === '') {
              field.style.borderColor = '#dc2626';
              return false;
            } else {
              field.style.borderColor = inputBorderColor;
              return true;
            }
          }

          // Validate on form submission
          const productForm = field.closest('form');
          if (productForm) {
            productForm.addEventListener('submit', function(e) {
              if (!validateField()) {
                e.preventDefault();
                field.focus();

                // Show error message
                let errorMsg = wrapper.querySelector('.field-error');
                if (!errorMsg) {
                  errorMsg = document.createElement('div');
                  errorMsg.className = 'field-error';
                  errorMsg.style.cssText = 'color: #dc2626; font-size: 12px; margin-top: 4px;';
                  errorMsg.textContent = 'This field is required.';
                  wrapper.appendChild(errorMsg);
                }

                // Remove error on input
                field.addEventListener('input', function() {
                  if (errorMsg && field.value.trim() !== '') {
                    errorMsg.remove();
                  }
                }, { once: true });
              }
            });
          }
        }

        // Store original cart form submission for line item properties
        const cartForm = document.querySelector('form[action*="/cart/add"]');
        if (cartForm && field.name.includes('properties')) {
          field.addEventListener('input', function() {
            // Auto-save to session storage for persistence
            sessionStorage.setItem('custom_field_' + fieldId, field.value);
          });

          // Restore from session storage
          const savedValue = sessionStorage.getItem('custom_field_' + fieldId);
          if (savedValue) {
            field.value = savedValue;
            if (hasMaxLength) {
              updateCounter();
            }
          }
        }
      }
    });
  }

  /* ── Concern G: reviews scroll (no Liquid interpolation, runs once) ── */
  function initReviewsScroll() {
    if (window.__hcsReviewScrollBound) return;
    window.__hcsReviewScrollBound = true;

    var REVIEW_ANCHORS = ['#shopify-product-reviews', '#hcs-reviews'];
    var HEADING_OFFSET = 20; /* px above the heading to stop */

    document.addEventListener('click', function(e) {
      /* Handle [data-scroll-to-reviews] (the reviews rating-component div) */
      var scrollDiv = e.target.closest('[data-scroll-to-reviews]');
      if (scrollDiv) {
        e.preventDefault();
        scrollToReviewsHeading();
        return;
      }

      /* Handle anchor links pointing to review section IDs */
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (REVIEW_ANCHORS.indexOf(href) === -1) return;

      e.preventDefault();
      scrollToReviewsHeading();
    });

    function scrollToReviewsHeading() {
      /* Try each known reviews section ID */
      var section = document.getElementById('hcs-reviews')
                 || document.getElementById('shopify-product-reviews');
      if (!section) return;

      /* Find the heading inside or immediately before the section */
      var heading = section.querySelector('h1, h2, h3, [class*="heading"], [class*="title"]');
      var target = heading || section;

      var rect = target.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var y = rect.top + scrollTop - HEADING_OFFSET;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-product-info-description-config-id]').forEach(initDescription);
    document.querySelectorAll('[data-product-info-dynamic-title-config-id]').forEach(initDynamicTitle);
    document.querySelectorAll('[data-product-info-atc-globals-config-id]').forEach(initAtcGlobals);
    document.querySelectorAll('[data-product-info-atc-button-config-id]').forEach(initAtcButton);
    document.querySelectorAll('[data-product-info-review-carousel-config-id]').forEach(initReviewCarousel);
    document.querySelectorAll('[data-product-info-custom-field-config-id]').forEach(initCustomField);
    initReviewsScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
